import { render } from "./AstBankverbindungenTr.pug?vue&type=template&id=45762583&lang=pug"
import script from "./AstBankverbindungenTr.js?vue&type=script&lang=js"
export * from "./AstBankverbindungenTr.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__